 $(document).ready(() => {
document.querySelectorAll('.interior').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.bedrooms').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.chairs').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.complements').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
    document.querySelectorAll('.lighting').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
    document.querySelectorAll('.sofas').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.surface-collection').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.table').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.tablewear').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
   document.querySelectorAll('.wellness-collection').forEach(function(el) {
      const parent = el.closest('.shopify-section');
      if (parent) {
          parent.classList.add('custom-sticky-style');
      }
  });
});